var map = {
	"./Approval.js": "./src/api/Approval.js",
	"./bs.js": "./src/api/bs.js",
	"./buyer.js": "./src/api/buyer.js",
	"./ci.js": "./src/api/ci.js",
	"./download.js": "./src/api/download.js",
	"./http.js": "./src/api/http.js",
	"./index.js": "./src/api/index.js",
	"./login.js": "./src/api/login.js",
	"./message.js": "./src/api/message.js",
	"./nmput.js": "./src/api/nmput.js",
	"./oa.js": "./src/api/oa.js",
	"./pi.js": "./src/api/pi.js",
	"./print.js": "./src/api/print.js",
	"./public.js": "./src/api/public.js",
	"./qg.js": "./src/api/qg.js",
	"./renovation.js": "./src/api/renovation.js",
	"./risk.js": "./src/api/risk.js",
	"./screen.js": "./src/api/screen.js",
	"./setUp.js": "./src/api/setUp.js",
	"./settlement.js": "./src/api/settlement.js",
	"./work.js": "./src/api/work.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/api sync \\.js$";